<template>
<div id="content-primary" class="t-main-content-margin">
  <div v-if="!membershipProofSent">
    <div class="o-width-limiter">
      <div class="c-intro">
          <div class="o-grid o-grid--space-between">
            <div class="o-grid__column c-intro__preamble" data-size="sm:12 md:6 lg:6 xl:6">
              <div class="s-text preamble">
                <h1 class="c-intro__heading">
                  Hämta medlemsbevis
                </h1><br>
                <p>
                  Ange ditt organisationsnummer och till vilken e-postadress medlemsbeviset ska skickas till.
                </p>
              </div>
            </div>
          </div>
        </div>
    </div>
  </div>
  <div class="o-width-limiter">
    <div class="o-grid">
      <div class="o-grid__column" data-size="sm:12 md:9 lg:9 xl:9">
        <div id="checkmembershipform" class="c-buffer-box c-buffer-box--extra-top c-buffer-box--no-bottom">
            <form name="form" @submit.prevent="handleSendProofOfMembership">
              <section id="failuremessage" v-if="message && !membershipProofSent && !isVerifiedMember" v-html="message" class="c-info-box c-info-box--very-important" role="alert">
                <span v-html="message"></span>
              </section>
              <section id="successmessage" v-if="isVerifiedMember" v-html="message" class="c-info-box c-info-box--default" role="alert">
                <span v-html="message"></span>
              </section>
              <div v-if="loading">
                  <div class="c-spinner">
                      <span class="t-visually-hidden">Hämtar ditt bevis</span>
                  </div>
              </div>
              <div v-if="!membershipProofSent" class="form-group">
                <div class="c-form__item">
                  <div class="c-rect-input">
                    <label
                      for="text"
                      class="c-rect-input__label">Organisationsnummer (10 siffror)
                    </label>
                    <input
                      v-model="user.organizationnumber"
                      v-validate="{ required: true, regex: /(?:[0-9]-?){10}/ }"
                      type="text"
                      id="orgnr"
                      name="orgnr"
                      class="c-rect-input__input"
                      />
                      <span>{{ errors.first('orgnr') }}</span>                    
                  </div>
                </div>
                <div
                  v-if="errors.has('organizationnumber')"
                  class="alert alert-danger"
                  role="alert">Mejladress måste fyllas i!
                </div>
              </div>
              <div v-if="!membershipProofSent" class="form-group">
                <div class="c-form__item">
                  <div class="c-rect-input">
                    <label
                      for="membershipProofEmail"
                      class="c-rect-input__label">E-post
                    </label>
                    <input
                      v-model="user.membershipProofEmail"
                      v-validate="{ required: true, regex: /.+@.+/ }"
                      type="text"
											id="email"
                      name="email"
                      class="c-rect-input__input"
                      />
                      <span>{{ errors.first('email') }}</span>                    
                  </div>
                </div>
                <div
                  v-if="errors.has('membershipProofEmail')"
                  class="alert alert-danger"
                  role="alert">Organisationsnummer måste fyllas i!
                </div>
              </div>
              <div v-if="!membershipProofSent" class="c-form-buttons ">
                <div class="c-form-buttons__button">
                  <input
                    class="c-button c-button--primary"
                    type="submit"
                    name="edit-method"
                    value="Nästa"
                    :disabled="loading"
                    id="<?= $submitId ?>">
                </div>
              </div>
                <div class="form-group o-width-limiter alert alert-success" role="alert" v-if="membershipProofSent">
                  <h2 class="c-block-section__heading">Nu är det klart!</h2>
                  <div v-html="message"></div>
                </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import User from '../models/user';

function decodeEntities(encodedString) {
    var textArea = document.createElement('textarea');
    textArea.innerHTML = encodedString;
    return textArea.value;
}

export default {
  name: 'SendProofOfMembership',
  data() {
    return {
      user: new User('', ''),
      loading: false,
      message: '',
      membershipProofSent: false,
    };
  },
  computed: {
    verifiedMembership() {
      return this.$store.state.ProofOfMembership.status.verifiedMembership;
    }
  },
  created() {
    if (this.verifiedMembership) {
      this.membershipProofSent = true;
      this.loading = false;
    }
  },
  methods: {
    handleSendProofOfMembership() {
      this.loading = true;
      this.$validator.validateAll().then(isValid => {
        if (!isValid) {
          this.loading = false;
          return;
        }
        
        if (this.user.organizationnumber && this.user.membershipProofEmail) {
          this.$store.dispatch('ProofOfMembership/verifyMembership', this.user).then(
            (response) => {
              this.membershipProofSent = true;
              this.loading = false;
              this.message = decodeEntities(response.message);
            },
            error => {
              this.loading = false;
              var defaultMessage = '<h1>Det gick inte att verifiera dina uppgifter!</h1>' +
              '<p>Som medlem kan du fortfarande hämta ditt medlemsbevis på mina sidor. Logga in ' +
              'eller skapa ett konto <a href="https://www.in.se/medlemskap/bli-medlem/#/">här</a>. ' +
              'Du kan också kontakta oss på <a href="mailto:info@in.se">info@in.se</a> eller' + 
              ' 08-762 76 00.</p>';
              this.message = (error.response && error.response.data && decodeEntities(error.response.data.message)) || defaultMessage;
            }
          );
        }
        
      });
    }
  }
};
</script>
